import { ReduxState } from 'app-types'
import get from 'lodash/get'
import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'

export const getAnalyticsData = (state: ReduxState) => {
  const data = get(state, 'analytics')
  return omitBy(data, isNil) // remove undefined keys
}
